class Profile {
  constructor() {

  }

  init() {

    let card = document.querySelector("#card");
    let profile = document.querySelector("#profile");

    function closeProfile(){
      if(!card.classList.contains('hidden')) {
        card.classList.add('hidden');
      }

    }

    if(profile !== null ){
      profile.addEventListener("click", function() {
        card.classList.toggle("hidden")})

      document.onclick = function(e){
        if (e.target.id !== 'card' && e.target.id !== 'profile') {
          if(e.target.offsetParent && e.target.offsetParent.id !== 'card' && e.target.offsetParent.id !== 'profile'){
            closeProfile()
          }
        }

      }
    }
  }
}

export default new Profile();



